import { fetchData } from "../../Helpers";
export const BALANCE_STALE_TIME = 1000 * 60 * 5.5;
export const BALANCE_CACHE_TIME = Infinity;

export function getBalanceStats(
  payload = {
    limit: 100,
    offset: 0,
  }
) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/balance/stats",
    successCallback: () => {},
    payload,
    controller: controller,
  });
}

export function getBalanceList(
  payload = {
    limit: 10,
    offset: 0,
  }
) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/balance/list",
    successCallback: () => {},
    payload,
    controller,
  });
}
